/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TournamentTeamCreate = {
    properties: {
        name: {
            type: 'TranslationCreate',
            isRequired: true,
        },
    },
} as const;
